import { render, staticRenderFns } from "./signreviw.vue?vue&type=template&id=2be006d5&"
import script from "./signreviw.vue?vue&type=script&lang=js&"
export * from "./signreviw.vue?vue&type=script&lang=js&"
import style0 from "./signreviw.vue?vue&type=style&index=0&id=2be006d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports